document.addEventListener('DOMContentLoaded', function () {
    // parallax
    const parallaxElements = document.querySelectorAll('.parallax');

    if (parallaxElements) {
        const height = window.innerHeight;
        function handleScroll() {
            const scrollPos = window.scrollY;
            parallaxElements.forEach(function (element, index) {
                const parent = element.parentNode;
                const parentHeight = parent.getBoundingClientRect().height;
                const elementTop = element.getBoundingClientRect().top;
                const elementHeight =
                    window.pageYOffset + element.getBoundingClientRect().top;
                element.style.top = `${(parentHeight - 100) / 100}px`;
                parent.style.overflow = 'visible';
                let translate;
                if (window.innerWidth < 767) {
                    translate = elementTop / 16;
                } else {
                    translate = (elementTop - 250) / 2;
                }

                if (elementHeight - height < scrollPos) {
                    element.style.transform = `translate3d(0, ${translate}px, 0)`;
                }
            });
        }

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }
});

